import { IElementHistory } from "core-integration/src/store/elements/types";
import { TFunction } from "i18next";
import { visuallyHidden } from "plos/src/styles/utils.css";
import { useTranslation } from "react-i18next";
import { historyResultStyles } from "./historyResult.css";

interface HistoryResultProps {
  history: IElementHistory;
}

// We use these descriptions as they need to be tense agnostic, as the score will be shown for both finished and ongoing matches in the history table.
const resultDict = (t: TFunction) => ({
  w: t("historyResult.winningTeam", "Winning team"),
  d: t("historyResult.draw", "Draw"),
  l: t("historyResult.losingTeam", "Losing team"),
});

const HistoryResult = ({ history }: HistoryResultProps) => {
  const { t } = useTranslation();
  const {
    was_home: wasHome,
    team_h_score: teamHScore,
    team_a_score: teamAScore,
  } = history;

  if (teamHScore == null || teamAScore == null) return null;

  const score = `${teamHScore} - ${teamAScore}`;

  const forScore = wasHome ? teamHScore : teamAScore;
  const againstScore = wasHome ? teamAScore : teamHScore;
  const resultType: "w" | "d" | "l" =
    forScore > againstScore ? "w" : forScore < againstScore ? "l" : "d";

  return (
    <span className={historyResultStyles[resultType]}>
      <span className={visuallyHidden}>
        {t("historyResult.score", "{{resultType}}, score:", {
          resultType: resultDict(t)[resultType],
        })}
      </span>
      {score}
    </span>
  );
};

export default HistoryResult;
